module.exports = __webpack_public_path__ + "img/chinesecompany215.0ffcce41.png";